import { useMutation, useQuery } from '@tanstack/react-query';
import {
    requestAvailableNumbers,
    requestCanChangeSicNumber,
    requestChangeSicNumber,
} from '../twilio/twilio';
import { AvailableNumbersRequest } from '../twilio/types/AvailableNumbersRequest';

export const useAvailableNumbers = (data: AvailableNumbersRequest, isValid: boolean) => {
    return useQuery({
        queryKey: ['availableNumbers', data],
        staleTime: 10000,
        enabled: isValid,
        queryFn: async () => (await requestAvailableNumbers(data)).data,
    });
};

export const useCanChangeSicNumber = () => {
    return useQuery({
        queryKey: ['canChangeSicNumber'],
        queryFn: async () => (await requestCanChangeSicNumber()).data,
    });
};

export const useChangeSicNumber = () => {
    return useMutation({
        mutationKey: ['changeSicNumber'],
        mutationFn: async (newNumber: string) => await requestChangeSicNumber(newNumber),
    });
};
